import React from "react";
import { TtableContainer, TtableTitle } from "./StyledTable";
import { FaDownload } from "react-icons/fa";
import { useStore } from "../../store";
import {
  getCmpFoodTotalExpenseDownloadService,
  getFoodTotalExpenseDownloadService,
} from "../../services/cFoodExpenseReportService";
import { adminEmpExpenseReportService } from "../../services/adminEmpExpenseReportService";

// import {
//   TableContainer,
//   TableTitle,
// } from "../../assets/StyledComponent/StyledTable";

interface Iitable {
  tableHeadList: string[];
  children: JSX.Element[] | JSX.Element;
  tableTitle?: string;
  companyId?: string;
  reportType?: string;
  companyName?: string;
}

const Ttable: React.FC<Iitable> = ({
  companyId,
  tableHeadList,
  companyName,
  children,
  tableTitle,
  reportType,
}) => {
  const [state, dispatch]: any = useStore();

  const fromDate = state.foodReportReducer?.fromDate;
  const toDate = state.foodReportReducer?.toDate;

  const getTableData = async () => {
    // const fromDateEng = date.fromDate.toISOString().slice(0, 10);
    // const toDateEng = date.toDate.toISOString().slice(0, 10);

    // var d = new Date(toDate);
    // // console.log("Today is: " + d.toLocaleString());

    // d.setDate(d.getDate() - 1);
    // const year = d.getFullYear().toString();
    // const month = String(d.getMonth() + 1).padStart(2, "0");
    // const day = String(d.getDate()).padStart(2, "0");
    // const to_date = toDate;
    if (reportType === "Food Report") {
      if (companyId) {
        getCmpFoodTotalExpenseDownloadService(fromDate, toDate, companyId);
      } else {
        getFoodTotalExpenseDownloadService(fromDate, toDate);
      }
    } else {
      if (companyId !== "") {
        adminEmpExpenseReportService(
          fromDate,
          toDate,
          companyId as string,
          companyName as string
        );
      }
    }
  };

  return (
    <TtableContainer>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          background: "#e6662c",
          color: "white",
        }}
      >
        {tableTitle && <TtableTitle>{tableTitle}</TtableTitle>}
        <div
          style={{
            marginRight: "10px",
            cursor: "pointer",
          }}
          onClick={getTableData}
        >
          <FaDownload size={"15"} color={"white"} />
        </div>
      </div>
      <table className="table bg-white table-borderless">
        <thead className="tableHead">
          <tr>
            {tableHeadList.map((tableHeading, index) => (
              <th key={index} className="styledTable">
                {tableHeading}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="tableBody">{children}</tbody>
      </table>
    </TtableContainer>
  );
};

export default Ttable;
